import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import React, { ReactNode, useState } from 'react';

type OptionType = {
	value: number | string;
	label: number | string | ReactNode;
};

interface IRadioProps {
	alignRow?: boolean;
	type: string;
	testId?: string;
	optionSelection: OptionType[];
	defaultValue: string | number;
	handleValueChange: (val: number | string) => void;
	disabled?: boolean;
}

const RadioGroupComp = (props: IRadioProps) => {
	const {
		alignRow = false,
		type,
		optionSelection,
		defaultValue,
		testId,
		handleValueChange,
		disabled = false,
	} = props;

	const handleChange = (event: any) => {
		setVal(type === 'number' ? Number(event.target.value) : event.target.value);
		handleValueChange(
			type === 'number' ? Number(event.target.value) : event.target.value,
		);
	};

	const [val, setVal] = useState(defaultValue);
	return (
		<FormControl>
			<RadioGroup
				aria-labelledby="demo-radio-buttons-group-label"
				defaultValue={defaultValue}
				name="radio-buttons-group"
				value={val}
				row={alignRow}
				onChange={handleChange}
				data-testid={testId}
			>
				{optionSelection.map(({ value, label }) => (
					<FormControlLabel
						value={value}
						key={value}
						control={<Radio disabled={disabled} />}
						label={label}
					/>
				))}
			</RadioGroup>
		</FormControl>
	);
};

export default RadioGroupComp;
